/**
 * features/settings/SettingsPage.tsx — รวม sub-tabs การตั้งค่าทั้งหมด
 */

import { useState } from 'react';
import { PageHeader } from '~/ui/layout';
import { cn } from '~/lib/cn';
import { CompanySettingsTab } from './CompanySettingsTab';
import { UsersSettingsTab } from './UsersSettingsTab';
import { ExpenseCategoriesTab } from './ExpenseCategoriesTab';
import { BackupTab } from './BackupTab';

const TABS = [
  { key: 'company', label: 'ข้อมูลบริษัท' },
  { key: 'users', label: 'ผู้ใช้งาน' },
  { key: 'categories', label: 'หมวดหมู่ค่าใช้จ่าย' },
  { key: 'backup', label: 'สำรอง/กู้คืนข้อมูล' },
] as const;

type TabKey = (typeof TABS)[number]['key'];

export function SettingsPage() {
  const [tab, setTab] = useState<TabKey>('company');

  return (
    <div>
      <PageHeader title="ตั้งค่า" description="ตั้งค่าข้อมูลบริษัท ผู้ใช้งาน และระบบ" />

      <div className="mb-5 flex gap-1 border-b border-border-base">
        {TABS.map((item) => (
          <button
            key={item.key}
            onClick={() => setTab(item.key)}
            className={cn(
              'border-b-2 px-3 py-2 text-sm font-medium transition-colors',
              tab === item.key
                ? 'border-accent text-accent-fg'
                : 'border-transparent text-fg-muted hover:text-fg',
            )}
          >
            {item.label}
          </button>
        ))}
      </div>

      {tab === 'company' ? <CompanySettingsTab /> : null}
      {tab === 'users' ? <UsersSettingsTab /> : null}
      {tab === 'categories' ? <ExpenseCategoriesTab /> : null}
      {tab === 'backup' ? <BackupTab /> : null}
    </div>
  );
}
